<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Item"
                @click.stop="abrirModalAtualizarItem()"
            ></i>
        </span>
        <b-modal
            id="modalAtualizarItem"
            v-model="mostrarModalAtualizarItem"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Item de Contrato -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O quê deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group
                            v-model="contratoApostilamento"
                            @change="alternaJustificativa($event)"
                        >
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <app-detalhe2 titulo="Nº">
                <strong>{{ item.ordem }}</strong>
            </app-detalhe2>
            <b-row v-if="contratoElaboracao()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo Produto</label>
                        <model-list-select
                            :list="tiposProduto"
                            option-text="nomeFantasia"
                            option-value="codigo"
                            v-model="tipoProduto.codigo"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- <b-row v-if="contratoElaboracao()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo Faturamento</label>
                        <model-list-select
                            :list="tiposFaturamento"
                            option-text="descricao"
                            option-value="codigo"
                            v-model="tipoFaturamento.codigo"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
            </b-row> -->
            <b-row v-if="contratoElaboracao()">
                <!-- <b-col sm="12">
                    <b-form-group>
                        <label>Natureza</label>
                        <model-list-select
                            :list="naturezas"
                            option-text="descricao"
                            option-value="codigo"
                            v-model="natureza.codigo"
                        ></model-list-select>
                    </b-form-group>
                </b-col> -->
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição</label>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="4"
                            @input="$v.descricao.$touch()"
                            :state="$v.descricao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição Resumida</label>
                        <b-form-textarea
                            v-model="descricaoResumida"
                            :rows="4"
                            :maxlength="200"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valor.$error ? false : null"
                        invalid-feedback="Valor é obrigatório"
                    >
                        <label>Valor</label>
                        <money
                            v-model="valor"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valor.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Quantidade</label>
                        <b-form-input
                            type="number"
                            v-model="quantidade"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{ labelJustificativa }}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{ textoInfoJustificativa }} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalAtualizarItem()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarItem()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import { situacaoContrato } from '../SituacaoContrato'
import ContratosServicos from './../ContratosServicos'
import { ModelListSelect } from 'vue-search-select'
import ContratoRmServicos from '../../rm/ContratosRMServicos'

export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        },

        contrato: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        }
    },

    components: {
        ModelListSelect
    },

    data() {
        return {
            mostrarModalAtualizarItem: false,
            obterItensAtualizados: false,
            operacao: 'ATUALIZAÇÃO',
            erros: [],
            descricao: '',
            descricaoResumida: '',
            valor: 0,
            quantidade: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            justificativaApostilamento: '',
            tiposProduto: [],
            tipoProduto: {
                codigo: '',
                nomeFantasia: ''
            },
            tiposFaturamento: [],
            tipoFaturamento: {
                codigo: '',
                descricao: ''
            },
            naturezas: [],
            natureza: {
                codigo: '',
                descricao: ''
            },
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        abrirModalAtualizarItem() {
            this.mostrarModalAtualizarItem = true
        },

        fecharModalAtualizarItem() {
            this.mostrarModalAtualizarItem = false
            this.resetAtualizarItem()
            if (this.obterItensAtualizados) {
                this.$emit('obterItensAtualizados')
            }
        },

        resetAtualizarItem() {
            this.justificativaApostilamento = ''
            this.descricao = ''
            this.descricaoResumida = ''
            this.valor = 0
            this.quantidade = 0
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.descricao = this.item.descricao.trim()
            this.descricaoResumida =
                this.item.descricaoResumida != null
                    ? this.item.descricaoResumida.trim()
                    : ''
            this.valor = this.item.valorUnitario
            this.quantidade = this.item.quantidade
            this.tipoProduto.codigo = this.item.codTipoProduto
                ? this.item.codTipoProduto
                : ''
            this.tipoFaturamento.codigo = this.item.codTipoFaturamento
                ? this.item.codTipoFaturamento
                : ''
            this.natureza.codigo = this.item.codNatureza
                ? this.item.codNatureza
                : ''
        },

        confirmarSalvarItem() {
            this.$swal({
                title: 'Item do Contrato',
                html: `Confirma a atualização do item Nº <b>${this.item.ordem}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvaritem()
                }
            })
        },

        buscaElemento(colecao, elementoCod) {
            return colecao.find((x) => x.codigo == elementoCod)
        },

        salvaritem() {
            this.$store.dispatch('addRequest')
            let itemAtualizadoDto = {
                idContrato: this.contrato.idContrato,
                itemContratoId: this.item.itemContratoId,
                itemReferenciaId: 0,
                descricao: this.descricao.trim(),
                descricaoResumida:
                    this.descricaoResumida != null
                        ? this.descricaoResumida.trim()
                        : '',
                valor: this.valor,
                quantidade: this.quantidade != null ? this.item.quantidade : 0,
                justificativaApostilamento: this.justificativaApostilamento,
                tipoProduto: this.buscaElemento(
                    this.tiposProduto,
                    this.tipoProduto.codigo
                ),
                tipoFaturamento: this.buscaElemento(
                    this.tiposFaturamento,
                    this.tipoFaturamento.codigo
                ),
                natureza: this.buscaElemento(
                    this.naturezas,
                    this.natureza.codigo
                ),
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            ContratosServicos.atualizarItemContrato(itemAtualizadoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.obterItensAtualizados = true
                            this.fecharModalAtualizarItem()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registrosInalterados() {
            if (this.descricao) {
                return (
                    this.descricao.trim() == this.item.descricao.trim() &&
                    this.descricaoResumida == this.item.descricaoResumida &&
                    this.valor == this.item.valorUnitario &&
                    this.tipoFaturamento.codigo ==
                        this.item.codTipoFaturamento &&
                    this.tipoProduto.codigo == this.item.codTipoProduto &&
                    this.quantidade == this.item.quantidade &&
                    this.natureza.codigo == this.item.codNatureza
                )
            }
            return false
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        verificaTipoProduto() {
            if (this.contratoElaboracao()) {
                if (this.tipoProduto.codigo.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },

        verificaTipoFaturamento() {
            if (this.contratoElaboracao()) {
                if (this.tipoFaturamento.codigo.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },

        verificaNatureza() {
            if (this.contratoElaboracao()) {
                if (this.natureza.codigo.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },

        obterTiposProdutoRM() {
            ContratoRmServicos.obterTiposProdutoRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposProduto = response.data
                    }
                }
            })
        },

        obterTiposFaturamentoRM() {
            ContratoRmServicos.obterTiposFaturamentoRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposFaturamento = response.data
                    }
                }
            })
        },

        obterNaturezasRM() {
            ContratoRmServicos.obterNaturezasRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.naturezas = response.data
                    }
                }
            })
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato ==
                situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

        verificaTiposAtualizacao() {
            if (
                (this.apostilamento || this.atualizacaoContrato()) &&
                this.contratoApostilamento != null
            ) {
                return true
            } else if (this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        },

        alternaJustificativaPorAcesso() {
            if (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.$temAcessoView('CONT-APOST-05')
            ) {
                this.contratoApostilamento = null
            } else if (this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if (this.$temAcessoView('CONT-APOST-05')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }
    },

    created() {
        this.alternaJustificativaPorAcesso()
        this.obterTiposProdutoRM()
        this.obterTiposFaturamentoRM()
        this.obterNaturezasRM()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        mostrarCheckApostilamento() {
            return this.atualizacaoContrato() && this.apostilamento
        }
    },

    watch: {},

    validations: {
        itemContratoId: {
            registrosAlterados() {
                return !this.registrosInalterados()
            }
        },
        descricao: {
            required
        },
        valor: {
            required,
            minValue: minValue(0.01)
        },
        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },
        tipoProduto: {
            verificaTipoProduto() {
                return this.verificaTipoProduto()
            }
        },
        // tipoFaturamento: {
        //     verificaTipoFaturamento() {
        //         return this.verificaTipoFaturamento()
        //     }
        // },
        // natureza: {
        //     verificaNatureza() {
        //         return this.verificaNatureza()
        //     }
        // },
        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        }
    }
}
</script>
